// Using the Y (week-numbering year) formatter without also including w (week number)
// is now detected as suspicious. Use y (year) if that was the intent, or include w alongside Y.
// For example: new Date('2021-01-01')
//  yyyy -> 2021
//  YYYY -> 2020
// Since angular 20 this change came into effect

export const CUSTOM_DATE_FORMATS = {
    parse: {
        dateInput: 'dd. MMM yyyy',
    },
    display: {
        dateInput: 'dd. MMM yyyy',
        monthYearLabel: 'MMM yyyy',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM yyyy',
    },
}

export const ADS_DATE_FORMAT = {
    parse: {
        dateInput: 'yyyy-MM-dd',
    },
    display: {
        dateInput: 'dd. MMM yyyy',
        monthYearLabel: 'MMM yyyy',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM yyyy',
    },
}

export const MESSAGE_DATE_FORMAT = {
    parse: {
        dateInput: 'DD.MM.YYYY HH:mm'
    },
    display: {
        dateInput: 'DD.MM.YYYY HH:mm',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY'
    }
};
